import _regeneratorRuntime from "@babel/runtime/regenerator";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import { asyncGetFingerprint2 } from '../plugins/useFingerprint2';
/**
 * 获取fjs的数据
 */

export var getFingerprintData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var fingerprintData, FP2Values;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return asyncGetFingerprint2();

          case 2:
            fingerprintData = _context.sent;
            FP2Values = {};
            fingerprintData.forEach(function (item) {
              _Object$assign(FP2Values, _defineProperty({}, item.key, item.value));
            }); // Object.fromEntries(
            //   fingerprintData.map((item) => [item.key, item.value])
            // )

            return _context.abrupt("return", FP2Values);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getFingerprintData() {
    return _ref.apply(this, arguments);
  };
}();